export default {
  name: 'Kaydırma Aracı ',
  buttons: [
    {
      title: 'Kaydırma',
      key: '[Boşluk / fare tekerleği + sürükle]'
    }
  ]
}
